<template>
  <div>
    <h3>Natures</h3>
    <div class="icon-list" v-bind:class="{ 'width-100': isWidth100}">
      <div v-for="nature in natures" :key="nature.id" class="amsom-button"
           @click="setSelectedCategoryAndRedirectToTypes(nature.id)">
        <button class="btn btn-secondary">
          <i :class="fontawesomeico(nature.id)"></i>
        </button>
        <span class="amsom-button-libelle">{{ nature.libelle }}</span>
      </div>
    </div>

  </div>
</template>

<script>

export default {
  name: "Natures",
  data() {
    return {
      selectedSollicitation: null,
      natures: this.$store.getters['natures/iCanWrite'].filter(nature => nature.type === this.$store.getters['types/selectedType'])
    }
  },
  methods: {
    setSelectedCategoryAndRedirectToTypes(natureID) {
      this.$store.dispatch('natures/setSelectedNature', natureID)
      this.$router.push({
        name: 'motifs',
        params: {sollicitation: this.selectedSollicitation}
      });
    },
    fontawesomeico(ID) {
      if (ID === "TECH") return 'fas fa-tools'
      return 'fas fa-cog'
    }
  },
  computed: {
    // natures() {
    //   // return JSON.parse(this.$store.getters['natures/'].natures).filter(nature => nature.type === this.$store.getters['types/'].selectedType)
    //   return this.$store.getters['natures/'].getMyNature().filter(nature => nature.type === this.$store.getters['types/'].selectedType)
    // },
    isWidth100() {
      if (this.natures.length < 4) return true
      return false
    }
  },
  mounted: function () {
    if (typeof this.$route.params.sollicitation !== 'undefined' && this.$route.params.sollicitation !== null) {
      this.selectedSollicitation = this.$route.params.sollicitation
    }
    this.$store.dispatch('natures/setSelectedNature', null)
    this.$store.dispatch('motifs/setSelectedMotif', null)
    this.$store.dispatch('entrees/setSelectedEntree', null)

    // if (this.natures.length === 1){
    //   this.$store.dispatch('natures/setSelectedNature', this.natures[0].id)
    //   this.$router.push({
    //     name: 'motifs',
    //     params: {sollicitation: this.selectedSollicitation}
    //   });
    // }
  }
}
</script>

<style scoped>

</style>